export const AddMaintenanceImageIconUrl =
  'https://imgdrop.imgix.net/1dde8dbf19a646bdab877766d0d424a4.svg';

export const MaintenanceImageIconUrl =
  'https://imgdrop.imgix.net/a002164d6b644bdb8323724bbb0e4a31.svg';
